<template>
  <div class="login-container">
    <div class="login-box">
      <h2>登 录</h2>
      <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef" label-width="0" class="login-form">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" prefix-icon="el-icon-user" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" type="password" placeholder="密码" @keyup.enter="handleLogin"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" class="login-button" @click="handleLogin">登录</el-button>
        </el-form-item>
      </el-form>
      <div class="login-tips" v-if="errorMessage">
        <p>{{ errorMessage }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { login, saveToken, saveUser } from '../api/auth';

const router = useRouter();
const loginFormRef = ref(null);
const loading = ref(false);
const errorMessage = ref('');

const loginForm = reactive({
  username: '',
  password: ''
});

const loginRules = {
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' }
  ]
};

const handleLogin = () => {
  loginFormRef.value.validate(async (valid) => {
    if (valid) {
      loading.value = true;
      errorMessage.value = '';
      
      try {
        const response = await login(loginForm.username, loginForm.password);
        
        if (response.data.success) {
          const { token, user } = response.data.data;
          saveToken(token);
          saveUser(user);
          
          ElMessage.success('登录成功');
          router.push('/');
        } else {
          errorMessage.value = response.data.message || '登录失败';
        }
      } catch (error) {
        console.error('登录错误:', error);
        errorMessage.value = '登录失败，请稍后重试';
      } finally {
        loading.value = false;
      }
    }
  });
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 120px);
  background-color: #f5f7fa;
}

.login-box {
  width: 350px;
  padding: 30px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-box h2 {
  text-align: center;
  margin-bottom: 25px;
  color: #303133;
}

.login-form {
  margin-bottom: 15px;
}

.login-button {
  width: 100%;
}

.login-tips {
  font-size: 14px;
  color: #f56c6c;
  text-align: center;
}
</style>